"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserRegisteredChallenges = loadUserRegisteredChallenges;
exports.loadUserGroupChallengeStats = loadUserGroupChallengeStats;
exports.challengeRegister = challengeRegister;
exports.loadUserChallenge = loadUserChallenge;
exports.updateUserChallenge = updateUserChallenge;
exports.getUserChallengeActivities = getUserChallengeActivities;
exports.getUserChallengeActivitiesAround = getUserChallengeActivitiesAround;
exports.getUserChallengeAttempts = getUserChallengeAttempts;
exports.getUserGroupChallenge = getUserGroupChallenge;
exports.setUserGroupChallenge = setUserGroupChallenge;
exports.watchUserRegisteredChallenges = watchUserRegisteredChallenges;
exports.watchLoadUserGroupChallengeStats = watchLoadUserGroupChallengeStats;
exports.watchRegisterChallenge = watchRegisterChallenge;
exports.watchLoadUserChallenge = watchLoadUserChallenge;
exports.watchUpdateUserChallenge = watchUpdateUserChallenge;
exports.watchGetUserChallengeActivities = watchGetUserChallengeActivities;
exports.watchGetUserChallengeActivitiesAround = watchGetUserChallengeActivitiesAround;
exports.watchGetUserChallengeAttempts = watchGetUserChallengeAttempts;
exports.watchLoadUserGroupChallenge = watchLoadUserGroupChallenge;
exports.watchSetUserGroupChallenge = watchSetUserGroupChallenge;
exports["default"] = exports.userChallengesSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _effects = require("redux-saga/effects");

var _selectors = require("./selectors");

var _actions = _interopRequireDefault(require("./actions"));

var _actions2 = _interopRequireDefault(require("../../challenge/actions"));

var _utils = require("../../../utils");

var _marked = _regeneratorRuntime2.mark(loadUserRegisteredChallenges),
    _marked2 = _regeneratorRuntime2.mark(loadUserGroupChallengeStats),
    _marked3 = _regeneratorRuntime2.mark(challengeRegister),
    _marked4 = _regeneratorRuntime2.mark(loadUserChallenge),
    _marked5 = _regeneratorRuntime2.mark(updateUserChallenge),
    _marked6 = _regeneratorRuntime2.mark(getUserChallengeActivities),
    _marked7 = _regeneratorRuntime2.mark(getUserChallengeActivitiesAround),
    _marked8 = _regeneratorRuntime2.mark(getUserChallengeAttempts),
    _marked9 = _regeneratorRuntime2.mark(getUserGroupChallenge),
    _marked10 = _regeneratorRuntime2.mark(setUserGroupChallenge),
    _marked11 = _regeneratorRuntime2.mark(watchUserRegisteredChallenges),
    _marked12 = _regeneratorRuntime2.mark(watchLoadUserGroupChallengeStats),
    _marked13 = _regeneratorRuntime2.mark(watchRegisterChallenge),
    _marked14 = _regeneratorRuntime2.mark(watchLoadUserChallenge),
    _marked15 = _regeneratorRuntime2.mark(watchUpdateUserChallenge),
    _marked16 = _regeneratorRuntime2.mark(watchGetUserChallengeActivities),
    _marked17 = _regeneratorRuntime2.mark(watchGetUserChallengeActivitiesAround),
    _marked18 = _regeneratorRuntime2.mark(watchGetUserChallengeAttempts),
    _marked19 = _regeneratorRuntime2.mark(watchLoadUserGroupChallenge),
    _marked20 = _regeneratorRuntime2.mark(watchSetUserGroupChallenge);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function loadUserRegisteredChallenges(apis, action) {
  var _action$payload, clientId, userId, limit, skip, status, search, fullResponse, UserRegisteredChallengesData, prevData, nextData, newData;

  return _regenerator["default"].wrap(function loadUserRegisteredChallenges$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, clientId = _action$payload.clientId, userId = _action$payload.userId, limit = _action$payload.limit, skip = _action$payload.skip, status = _action$payload.status, search = _action$payload.search;
          _context.next = 4;
          return apis.userApi.getUserRegisteredChallengesNew({
            clientId: clientId,
            userId: userId,
            limit: limit,
            skip: skip,
            status: status,
            search: search
          }).then(function (p) {
            return p.request;
          });

        case 4:
          fullResponse = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_selectors.userRegisteredChallengesDataSelector);

        case 7:
          UserRegisteredChallengesData = _context.sent;
          prevData = UserRegisteredChallengesData || [];
          nextData = fullResponse.data || [];
          newData = [].concat((0, _toConsumableArray2["default"])(prevData), (0, _toConsumableArray2["default"])(nextData));
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserRegisteredChallengesSuccess(_objectSpread({}, fullResponse, {
            data: newData,
            meta: fullResponse.meta
          })));

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          _context.next = 19;
          return (0, _effects.put)(_actions["default"].loadUserRegisteredChallengesError(true));

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 15]]);
}

function loadUserGroupChallengeStats(apis, action) {
  var _action$payload2, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserGroupChallengeStats$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, challengeId = _action$payload2.challengeId, clientId = _action$payload2.clientId, userId = _action$payload2.userId;
          _context2.prev = 1;
          _context2.next = 4;
          return apis.userApi.getUserChallengeStats({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context2.sent;
          _context2.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeStatsSuccess({
            data: data
          }));

        case 7:
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeStatsError(true));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 9]]);
}

function challengeRegister(apis, action) {
  var _action$payload3, userId, clientId, challengeId, code, restart, groupId, language, defaultLanguage, payload;

  return _regenerator["default"].wrap(function challengeRegister$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, userId = _action$payload3.userId, clientId = _action$payload3.clientId, challengeId = _action$payload3.challengeId, code = _action$payload3.code, restart = _action$payload3.restart, groupId = _action$payload3.groupId, language = _action$payload3.language, defaultLanguage = _action$payload3.defaultLanguage;
          payload = {
            challenge: challengeId,
            restart: restart
          };

          if (groupId) {
            payload.group = groupId;
          }

          if (code) {
            payload.code = code;
          }

          _context3.prev = 4;

          if (!restart) {
            _context3.next = 10;
            break;
          }

          _context3.next = 8;
          return apis.userApi.restartChallenge({
            userId: userId,
            clientId: clientId,
            challengeId: challengeId
          }).then(function (p) {
            return p.request;
          });

        case 8:
          _context3.next = 12;
          break;

        case 10:
          _context3.next = 12;
          return apis.userApi.registerChallenge({
            userId: userId,
            clientId: clientId,
            payload: payload
          }).then(function (p) {
            return p.request;
          });

        case 12:
          _context3.next = 14;
          return (0, _effects.put)(_actions["default"].challengeRegisterSuccess());

        case 14:
          _context3.next = 16;
          return (0, _effects.put)(_actions2["default"].loadChallenge({
            challengeId: challengeId,
            clientId: clientId,
            language: language,
            defaultLanguage: defaultLanguage
          }));

        case 16:
          _context3.next = 18;
          return (0, _effects.put)(_actions["default"].loadUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }));

        case 18:
          _context3.next = 24;
          break;

        case 20:
          _context3.prev = 20;
          _context3.t0 = _context3["catch"](4);
          _context3.next = 24;
          return (0, _effects.put)(_actions["default"].challengeRegisterError(_context3.t0));

        case 24:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 20]]);
}

function loadUserChallenge(apis, action) {
  var _ref, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserChallenge$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref = action.payload || {}, challengeId = _ref.challengeId, clientId = _ref.clientId, userId = _ref.userId;
          _context4.prev = 1;
          _context4.next = 4;
          return apis.userApi.getUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeSuccess(data));

        case 7:
          _context4.next = 13;
          break;

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeError(_context4.t0));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 9]]);
}

function updateUserChallenge(apis, action) {
  var _action$payload4, challengeId, clientId, data, userId;

  return _regenerator["default"].wrap(function updateUserChallenge$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload4 = action.payload, challengeId = _action$payload4.challengeId, clientId = _action$payload4.clientId, data = _action$payload4.data, userId = _action$payload4.userId;
          _context5.prev = 1;
          _context5.next = 4;
          return apis.userApi.updateUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId,
            data: data
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(_actions["default"].updateUserChallengeSuccess());

        case 6:
          _context5.next = 8;
          return (0, _effects.put)(_actions["default"].loadUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }));

        case 8:
          _context5.next = 14;
          break;

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 14;
          return (0, _effects.put)(_actions["default"].updateUserChallengeError());

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 10]]);
}

function getUserChallengeActivities(apis, action) {
  var _action$payload5, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function getUserChallengeActivities$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload5 = action.payload, challengeId = _action$payload5.challengeId, clientId = _action$payload5.clientId, userId = _action$payload5.userId;
          _context6.prev = 1;
          _context6.next = 4;
          return apis.userApi.getUserChallengeActivities({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context6.sent;
          _context6.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesSuccess({
            data: data
          }));

        case 7:
          _context6.next = 13;
          break;

        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesError());

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 9]]);
}

function getUserChallengeActivitiesAround(apis, action) {
  var _action$payload6, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function getUserChallengeActivitiesAround$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _action$payload6 = action.payload, challengeId = _action$payload6.challengeId, clientId = _action$payload6.clientId, userId = _action$payload6.userId;
          _context7.prev = 1;
          _context7.next = 4;
          return apis.userApi.getUserChallengeActivitiesAround({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context7.sent;
          _context7.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesAroundSuccess({
            data: data
          }));

        case 7:
          _context7.next = 13;
          break;

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](1);
          _context7.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesAroundError());

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 9]]);
}

function getUserChallengeAttempts(apis, action) {
  var _action$payload7, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function getUserChallengeAttempts$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _action$payload7 = action.payload, challengeId = _action$payload7.challengeId, clientId = _action$payload7.clientId, userId = _action$payload7.userId;
          _context8.prev = 1;
          _context8.next = 4;
          return apis.userApi.getUserChallengeAttempts({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context8.sent;
          _context8.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeAttemptsSuccess({
            data: data
          }));

        case 7:
          _context8.next = 13;
          break;

        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](1);
          _context8.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeAttemptsError());

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[1, 9]]);
}

function getUserGroupChallenge(apis, action) {
  var _ref2, resourceType, resourceId, id, withMembers, data;

  return _regenerator["default"].wrap(function getUserGroupChallenge$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref2 = action.payload || {}, resourceType = _ref2.resourceType, resourceId = _ref2.resourceId, id = _ref2.id, withMembers = _ref2.withMembers;
          _context9.prev = 1;
          _context9.next = 4;
          return apis.groupsApi.getOneResourceGroup({
            resourceType: resourceType,
            resourceId: resourceId,
            id: id,
            withMembers: withMembers
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context9.sent;
          _context9.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeSuccess(data));

        case 7:
          _context9.next = 13;
          break;

        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](1);
          _context9.next = 13;
          return (0, _effects.put)(_actions["default"].userGroupChallengeRequestError());

        case 13:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[1, 9]]);
}

function setUserGroupChallenge(action) {
  return _regenerator["default"].wrap(function setUserGroupChallenge$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(_actions["default"].setUserGroupChallengeSuccess(action.payload));

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function watchUserRegisteredChallenges(apis) {
  return _regenerator["default"].wrap(function watchUserRegisteredChallenges$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserRegisteredChallenges), loadUserRegisteredChallenges, apis);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function watchLoadUserGroupChallengeStats(apis) {
  return _regenerator["default"].wrap(function watchLoadUserGroupChallengeStats$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserGroupChallengeStats), loadUserGroupChallengeStats, apis);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function watchRegisterChallenge(apis) {
  return _regenerator["default"].wrap(function watchRegisterChallenge$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].challengeRegister), challengeRegister, apis);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function watchLoadUserChallenge(apis) {
  return _regenerator["default"].wrap(function watchLoadUserChallenge$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallenge), loadUserChallenge, apis);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function watchUpdateUserChallenge(apis) {
  return _regenerator["default"].wrap(function watchUpdateUserChallenge$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].updateUserChallenge), updateUserChallenge, apis);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

function watchGetUserChallengeActivities(apis) {
  return _regenerator["default"].wrap(function watchGetUserChallengeActivities$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeActivities), getUserChallengeActivities, apis);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}

function watchGetUserChallengeActivitiesAround(apis) {
  return _regenerator["default"].wrap(function watchGetUserChallengeActivitiesAround$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeActivitiesAround), getUserChallengeActivitiesAround, apis);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}

function watchGetUserChallengeAttempts(apis) {
  return _regenerator["default"].wrap(function watchGetUserChallengeAttempts$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeAttempts), getUserChallengeAttempts, apis);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18);
}

function watchLoadUserGroupChallenge(apis) {
  return _regenerator["default"].wrap(function watchLoadUserGroupChallenge$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserGroupChallengeRequest), getUserGroupChallenge, apis);

        case 2:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19);
}

function watchSetUserGroupChallenge() {
  return _regenerator["default"].wrap(function watchSetUserGroupChallenge$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].setUserGroupChallengeAttempt), setUserGroupChallenge);

        case 2:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20);
}

var userChallengesSagas = function userChallengesSagas(apis) {
  return [(0, _effects.fork)(watchGetUserChallengeActivities, apis), (0, _effects.fork)(watchGetUserChallengeActivitiesAround, apis), (0, _effects.fork)(watchGetUserChallengeAttempts, apis), (0, _effects.fork)(watchLoadUserChallenge, apis), (0, _effects.fork)(watchLoadUserGroupChallengeStats, apis), (0, _effects.fork)(watchRegisterChallenge, apis), (0, _effects.fork)(watchUpdateUserChallenge, apis), (0, _effects.fork)(watchUserRegisteredChallenges, apis), (0, _effects.fork)(watchLoadUserGroupChallenge, apis), (0, _effects.fork)(watchSetUserGroupChallenge)];
};

exports.userChallengesSagas = userChallengesSagas;
var _default = userChallengesSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map